import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
    private http = inject(HttpClient);
    private apiUrl = `${environment.apiUrl}/users`;

    // SystemAdmin/Admin: Create user
    create(user: any): Observable<any> {
        return this.http.post(this.apiUrl, user);
    }

    // Get user list
    getAll(): Observable<any[]> {
        return this.http.get<any[]>(this.apiUrl);
    }

    // Admin: Update user
    update(id: string, data: any): Observable<any> {
        return this.http.put(`${this.apiUrl}/${id}`, data);
    }

    // Delete user
    delete(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${id}`);
    }

    // User: Update own profile
    updateProfile(data: any): Observable<any> {
        return this.http.put(`${this.apiUrl}/profile`, data);
    }

    // Admin: Change user roles
    changeRoles(userId: string, roles: string[]): Observable<any> {
        return this.http.post(`${this.apiUrl}/${userId}/roles`, { roles });
    }

    // Get all available roles
    getRoles(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/roles`);
    }

    // Get current user profile
    getProfile(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/profile`);
    }
}
